import { Component, Input, Output, EventEmitter, ViewChild, ElementRef, AfterViewInit, inject } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { ComingSoonComponent } from "../../../../shared/components/coming-soon/coming-soon.component";
import { AssetVersionPipe } from '../../../../pipes/asset-version.pipe';
import { CommonModule } from '@angular/common';
import { TippyDirective } from '@ngneat/helipopper';
import { PremiumTooltipComponent } from '../../../../shared/components/premium-tooltip/premium-tooltip.component';
import { tooltips } from '../../../../utils/tooltips';
import { AuthorizationService } from '../../../../services/authorization.service';
import { PolarisModelVersion } from '../../../../services/polaris/model';
import { PolarisModelSelectorComponent } from '../polaris-model-selector/polaris-model-selector.component';

@Component({
  selector: 'app-copilot-prompt-bar',
  imports: [
    ReactiveFormsModule,
    ComingSoonComponent,
    AssetVersionPipe,
    CommonModule,
    TippyDirective,
    PremiumTooltipComponent,
    PolarisModelSelectorComponent
  ],
  templateUrl: './copilot-prompt-bar.component.html',
  styleUrl: './copilot-prompt-bar.component.scss'
})

export class CopilotPromptBarComponent implements AfterViewInit {
  @Input() promptControl!: FormControl;
  @Input() maxHeight = 156;
  @Input() shouldDisplayExtraButtons = false;
  @Input() placeholder = "Ask me anything about your brand, campaigns, or competitors";
  @Input() showModelSelector = false;
  @Input() selectedModel: PolarisModelVersion = 'v2';
  @Input() modelSelectorDisabled = false;
  @Output() sendMessage = new EventEmitter<string>();
  @Output() modelChange = new EventEmitter<PolarisModelVersion>();
  @ViewChild('promptInput', { static: false }) promptInput!: ElementRef<HTMLTextAreaElement>;
  @ViewChild('promptBarContainer', { static: false }) promptBarContainer!: ElementRef<HTMLDivElement>;

  private authorizationService = inject(AuthorizationService);
  protected readonly tooltips = tooltips;
  protected isExpiredUser: boolean;
  protected isGalleryHovered = false;
  protected isClipHovered = false;

  constructor() {
    this.isExpiredUser = this.authorizationService.isExpiredUser;
  }

  ngAfterViewInit(): void {
    this.focusPromptInput();
    this.promptInput.nativeElement.style.height = '24px';
    this.promptBarContainer.nativeElement.style.maxHeight = this.maxHeight + 'px';
  }

  focusPromptInput(): void {
    if (this.isExpiredUser) return;

    this.promptInput?.nativeElement.focus();
  }

  resizeTextArea() {
    if (this.isExpiredUser) return;

    this.promptInput.nativeElement.style.height = '24px'; // reset to base before calculating
    const newHeight = Math.min(this.promptInput.nativeElement.scrollHeight, this.maxHeight - 50); // limit to 100px
    if (newHeight > 24) {
      this.promptInput.nativeElement.style.height = `${newHeight}px`;
      this.promptInput.nativeElement.style.marginBottom = '28px';
    } else {
      this.promptInput.nativeElement.style.marginBottom = '0px';
    }
  }

  onSend(event?: Event): void {
    if (this.isExpiredUser) return;

    event?.preventDefault();

    if (this.promptControl.value?.trim()) {
      this.sendMessage.emit(this.promptControl.value);
      this.promptControl.setValue('');
    }
  }

}
